import { UnitObject } from "@common/types/tree-types";
import { UnitRepository } from "./unit-repository";

export const searchUnitsList = (
  searchString: string,
  unitRepo: UnitRepository = new UnitRepository(),
): UnitObject[] | undefined => {
  if (!searchString) return;
  return unitRepo
    .getUnits()
    .filter(
      (unit) =>
        unit.display_name.toLowerCase().includes(searchString.toLowerCase()) ||
        unit.description.toLowerCase().includes(searchString.toLowerCase()) ||
        unit.code.toString().includes(searchString.toLowerCase()),
    );
};
